export const tr = {
    bannersNo: 'Reklam',
    changedParameter: 'Değişiklik parametresi',
    changedValue: 'Değişen',
    cid: 'Kampanya',
    date: 'Tarih ve saat',
    groupNo: 'Grup',
    'moscow-time': "Moskova'ya göre",
    number: '№',
    userName: 'Değiştiren'
};
